export default __webpack_public_path__ + "img/tab-tips-552ec778.png";